// src/pages/AppDashboard.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LocalStorageService from '../services/LocalStorageService';
import { useUser } from "../context/UserContext";
import { ArrowLeft } from "lucide-react"
import BuildSystemInfo from './../data/BuildSystemInfo'

const Settings = () => {
  const navigate = useNavigate();

  const { user, logoutUser } = useUser();
  const logout = () => {
    logoutUser();
    navigate("/login");
  }

  return (
    <div className="container mx-auto max-w-md p-6">
      <div className="mb-8">
        <Link to="/app" className="inline-flex items-center text-gray-600 mb-4">
          <ArrowLeft className="w-5 h-5 mr-1" />
          BACK
        </Link>
        <h1 className="text-2xl font-bold">Settings</h1>
      </div>

      <p className="text-gray-600 mb-6">You are signed in as {user && user.email}</p>

      <div className="space-y-3 mb-8">
        <button className="w-full bg-gray-100 text-gray-900 rounded-lg py-3 font-medium" onClick={logout}>LOG OUT</button>
        <button className="w-full bg-gray-100 text-gray-900 rounded-lg py-3 font-medium">DELETE ACCOUNT</button>
      </div>

      <div className="text-center text-sm text-gray-600 space-y-4">
        <p>
          Having issues?{" "}
          <a href={`mailto:${BuildSystemInfo.email}`} className="underline">
            Email me
          </a>
        </p>
        <p>
          Built with ❤️ by{" "}
          <a href={BuildSystemInfo.systemApp} className="text-red-500" target='_blank'>
            {BuildSystemInfo.buildedBy}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Settings;